// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Buefy from 'buefy'
import Lang from './lang'
import router from './router'
import VueI18n from 'vue-i18n'
import VueSession from 'vue-session'
import VueResource from 'vue-resource'
import VuePassword from 'vue-password'
import VueProgressBar from 'vue-progressbar'
import VueGkValidator from 'vue-gk-validator'
import VueGSignInButton from 'vue-google-signin-button'
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { faEllipsisV, faLocationArrow, faEnvelope, faCheck, faLock, faPaperclip, faBars, faRocket, faTimes, faExpand, faCompress, faSignOutAlt, faUserCog, faUserAstronaut, faCode, faUserPlus, faSearch, faList, faPause, faGripHorizontal, faCertificate, faCloudDownloadAlt, faCalendar, faAngleLeft, faAngleRight, faEye, faAngleDown, faAngleUp, faFileExcel, faFilePdf } from '@fortawesome/free-solid-svg-icons'
import { faEdit, faPlusSquare, faMinusSquare, faCaretSquareDown, faComments, faStickyNote, faQuestionCircle } from '@fortawesome/free-regular-svg-icons'
import { faFacebook, faGrav } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// Geckode
import './assets/css/util.css'
import 'buefy/dist/buefy.css'
import './assets/css/carquidiocesanos.css'
// import 'vue-tour/dist/vue-tour.css'
// Libraries
library.add(
  faEllipsisV, faLocationArrow, faEnvelope, faCheck, faLock, faPaperclip, faBars, faRocket, faTimes, faExpand, faCompress, faSignOutAlt, faUserCog, faUserAstronaut, faCode, faUserPlus, faSearch, faList, faPause, faGripHorizontal, faCertificate, faCloudDownloadAlt, faCalendar, faAngleLeft, faAngleRight, faEye, faAngleDown, faAngleUp, faFileExcel, faFilePdf,
  faEdit, faPlusSquare, faMinusSquare, faCaretSquareDown, faComments, faStickyNote, faQuestionCircle,
  faFacebook, faGrav
)
dom.watch()
// barcolors
var colors = '#e9bf4d'
// var color = color
// Vue.use
Vue.use(Buefy)
Vue.use(VueI18n)
Vue.use(VueSession)
Vue.use(VueResource)
Vue.use(VueProgressBar, {color: colors, failedColor: '#ff3860', thickness: '7px'})
Vue.use(VueGkValidator)
Vue.use(VueGSignInButton)
// Vue.components
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component(VuePassword)
// Config
router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})
Vue.config.productionTip = false
// BEFORE create vue object
const messages = Lang
const i18n = new VueI18n({ // documentation: http://kazupon.github.io/vue-i18n/guide/started.html#html
  locale: 'es',
  messages
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  i18n
})



// WEBPACK FOOTER //
// ./src/main.js